import axios from "axios";
import { milestoneRequestChangesUrl } from "../../utils";

export const milestoneRequestChanges = (
  projectId: string,
  milestoneId: string
) => {
  return axios.post(milestoneRequestChangesUrl(projectId, milestoneId));
};
